import { stringify } from "qs";
import { NextRouter } from "next/router";

export function updateCruiseIndexUrl(param: any, router: NextRouter): void {
  let newUrl = `/cruises?${stringify(param, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.replace(newUrl, null, { shallow: true });
}

export function updateCruiseShowUrl(param: any, router: NextRouter): void {
  let newUrl = `${location.pathname}?${stringify(param, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.replace(newUrl, null, { shallow: true });
}
